import { Typography } from 'antd';
import { UI_TEXT } from '../constants';
import logoImage from '@/assets/images/STX_Logo.png';

const { Title, Text } = Typography;

/**
 * Login Header Component
 * Displays logo and page title horizontally
 */
export const LoginHeader: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', marginBottom: '32px' }}>
      {/* Logo and Title - Horizontal Layout */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          marginBottom: '12px',
        }}
      >
        <img
          src={logoImage}
          alt="STX Logo"
          style={{
            width: '120px',
            height: '48px',
            objectFit: 'contain',
          }}
        />
        <Title level={2} style={{ margin: 0 }}>
          {UI_TEXT.TITLE}
        </Title>
      </div>
      <Text type="secondary">{UI_TEXT.SUBTITLE}</Text>
    </div>
  );
};
